import { StyleSheet } from '@react-pdf/renderer';
import { ArialRegural, ArialB600, RationValWidth } from '../fonts/font';

const borderColor = '#002D62';
const borderW = 1;
export const membraneStyle = StyleSheet.create({
  mainTable: {
    overflow: 'hidden',
    border: borderW,
    borderRadius: 5,
    width: '100%',
    borderColor,
  },
  tableRow: {
    flexDirection: 'row',
    overflow: 'hidden',
    color: '#ffffff',
    fontFamily: ArialRegural,
    fontSize: RationValWidth(16),
  },
  tableRow1: {
    marginTop: '-1px',
    flexDirection: 'row',
    overflow: 'hidden',
  },
  tableCol: {
    borderRight: borderW,
    borderColor,
    backgroundColor: borderColor,
    overflow: 'hidden',
    justifyContent: 'center'
  },
  tableCell: {
    fontFamily: ArialRegural,
    fontSize: RationValWidth(16),
    padding: '5 0'
  },
  flexDirection: {
    flexDirection: 'row',
    fontFamily: ArialRegural,
  },
  restChild: {
    textAlign: 'center',
    width: '100%',
  },
  textHeader: {
    // flexDirection: 'row',
    fontSize: RationValWidth(20),
    color: '#272B30',
    fontFamily: ArialB600,
  },
  tablebodyRow1: {
    flexDirection: 'row',
    borderTop: borderW,
    borderColor,
  },
  tablebodyCol1: {
    textAlign: 'center',
    justifyContent: 'center',
    width: '50%',
    borderRight: 1,
    borderColor,
  },
  mainHeader: {
    flexDirection: 'row',
    color: borderColor,
    fontFamily: ArialB600,
    alignItems: 'center'
  },
  notes: {
    fontFamily: ArialRegural,
    fontSize: RationValWidth(12),
    color: '#ff0000',
    marginTop: RationValWidth(12)
  }
});
